import { validateField, validateForm } from '../../../utils/form-validator-utils';
import React, { useState, useEffect } from 'react';
import loginImage from '../../../assets/images/loginImgnew.png';
import logo from '../../../assets/images/logo-trans.png';
// import Container from '../../../components/shared/container';
import { useNavigate } from 'react-router-dom';
import { loginUser, getAuthStatus } from '../../../services/auth-service';
import LoginForm from './form';
import Loader from '../../../components/shared/loader';

const Login = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: localStorage.getItem('rememberEmail') || '',
        password: '',
        rememberMe: !!localStorage.getItem('rememberEmail')
    });
    const [isCheckingAuth, setIsCheckingAuth] = useState(!!localStorage.getItem('authToken'));

    useEffect(() => {
        const checkExistingAuth = async () => {
            const token = localStorage.getItem('authToken');
            if (token) {
                setIsCheckingAuth(true);
                try {
                    const response = await getAuthStatus(token);
                    if (response.success) {
                        navigate('/dashboard');
                        return; // Keep loader visible until navigate happens
                    }
                } catch (error) {
                    console.error('Auth verification failed:', error);
                } finally {
                    setIsCheckingAuth(false);
                }
            }
        };
        checkExistingAuth();
    }, [navigate]);

    const [errors, setErrors] = useState({
        email: '',
        password: '',
        apiError: ''
    });

    // const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        // Validate on change if there's already an error
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: validateField(name, value)
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { errors: validationErrors, isValid } = validateForm(formData, ['email', 'password']);
        setErrors({ ...validationErrors, apiError: '' });
        // setSuccessMessage('');
        if (!isValid) return;

        setIsSubmitting(true);
        try {
            const response = await loginUser(formData);
            console.log(response)
            if (response.success) {
                // Handle Remember Me
                if (formData.rememberMe) {
                    localStorage.setItem('rememberEmail', formData.email);
                } else {
                    localStorage.removeItem('rememberEmail');
                }

                localStorage.setItem('authToken', response.data.data.token);
                localStorage.setItem('refreshToken', response.data.data.refreshToken);
                localStorage.setItem('user', JSON.stringify(response.data.data.user));
                // setSuccessMessage('Login successful! Redirecting to dashboard...');
                setTimeout(() => {
                    navigate('/dashboard');
                }, 1000);
            } else {
                setErrors(prev => ({
                    ...prev,
                    apiError: response.data.message || 'Login failed. Please try again.'
                }));
            }
        } catch (error) {
            setErrors(prev => ({
                ...prev,
                apiError: error.message || 'An unexpected error occurred.'
            }));
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isCheckingAuth) {
        return (
            <div className="relative min-h-screen flex items-center justify-center">
                <div className="absolute inset-0 opacity-50 bg-white blur-md"></div>

                <div className="relative z-10 flex flex-col items-center gap-4">
                    <img src={logo} className="h-12 object-contain mb-4" alt="Logo" />
                    <Loader message="Verifying session..." />
                </div>
            </div>

        );
    }

    return (
        <div className="grid bg-bg  md:grid-cols-2 grid-cols-1 !px-0 gap-6 min-h-screen">
            <div className='p-8 md:flex hidden'>
                <img src={loginImage} className='w-full h-full object-contain' alt="Login illustration" />
            </div>
            <div className='flex bg-white justify-start py-6 sm:px-8 px-4'>
                <div className='flex flex-col items-center justify-center xl:w-[75%] lg:w-[85%] w-full'>
                    <img
                        src={logo}
                        className="h-9 object-contain"
                        alt="Logo"
                    />
                    <div className='w-full mt-3'>
                        <h2 className='sm:text-xl text-lg text-center font-bold text-gray-800 mb-6'>Sign in to your account</h2>
                        {/* {successMessage && (
                            <div
                                className="mb-4 p-3 bg-green-100 text-green-700 text-sm rounded-lg text-center"
                                role="alert"
                            >
                                {successMessage}
                            </div>
                        )} */}
                        {errors.apiError && (
                            <div
                                className="mb-4 p-3 bg-red-100 text-red-700 text-sm rounded-lg text-center"
                                role="alert"
                            >
                                {errors.apiError}
                            </div>
                        )}
                        <LoginForm
                            handleSubmit={handleSubmit}
                            formData={formData}
                            handleChange={handleChange}
                            errors={errors}
                            isSubmitting={isSubmitting}
                        />
                    </div>

                    <p className='text-gray-400 text-center mt-6 text-sm'>© 2025 YoGPS™. All rights reserved.</p>

                </div>
            </div>
        </div>
    );
};


export default Login;